
import { Component, Vue, Watch } from "vue-property-decorator";
import { ScanforAcceptPacketGetOnModule } from "@/store/modules/store_scanforacceptpacketgeton";

@Component({
  name: "Form2",
})
export default class extends Vue {
  get GetOrderDestnationOrgFlag() {
    return ScanforAcceptPacketGetOnModule.checked_getorderdestnationorg;
  }
  set GetOrderDestnationOrgFlag(state) {
    ScanforAcceptPacketGetOnModule.GetOrderDestnationOrgChangeState(state);
  }

  get VoiceFlag() {
    return ScanforAcceptPacketGetOnModule.checked_voice;
  }
  set VoiceFlag(state) {
    ScanforAcceptPacketGetOnModule.VoiceChangeState(state);
  }



  mounted() {
    this.GetOrderDestnationOrgFlag = true;
    this.VoiceFlag = false;
  }
}
